module.exports = __webpack_public_path__ + "static/dennis_crowley-b2fdddeb6b026e51843294c56334d215.jpg";